import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export type ArticleDiagramContent = {
  title: string
  caption: string
  note: string
  steps: { title: string; description: string }[]
}

export function ArticleDiagram({
  content,
  icon,
}: {
  content: ArticleDiagramContent
  icon: 'chip' | 'network' | 'code'
}) {
  return (
    <figure className="article-diagram">
      <div className="diagram-heading">
        <PortfolioIcon name={icon} />
        <h3>{content.title}</h3>
      </div>
      <ol className="diagram-steps">
        {content.steps.map((step, index) => (
          <li key={step.title}>
            <span className="diagram-step-number">0{index + 1}</span>
            <h4>{step.title}</h4>
            <p>{step.description}</p>
          </li>
        ))}
      </ol>
      <p className="diagram-note">{content.note}</p>
      <figcaption>{content.caption}</figcaption>
    </figure>
  )
}
